import React, { useState, useRef, useEffect } from 'react';
import styles from './Tooltip.module.scss';
import cx from 'classnames';

const Tooltip = ({
  text = '',
  isHover,
  classNameTooltip,
  classNameText,
  position = null,
  fullwidth,
  children,
  wrapperRef = null,
  y_offset = 10,
  x_offset = 10,
  moveable = true,
  topPosition = 50,
  tooltipStyle = null,
}) => {
  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView] = useState(mediaMatch.matches);

  const tooltipRef = useRef(null);

  useEffect(() => {
    if (!tooltipRef.current || tooltipStyle != null) {
      return;
    }

    if (isHover) {
      const {
        top: tooltipTop,
        height: tooltipHeight,
        width: tooltipWidth,
        left: tooltipLeft,
      } = tooltipRef.current.getBoundingClientRect();
      let wrapperTopPosition = 0;

      if (wrapperRef?.current) {
        const { top: wrapperTop, height: wrapperHeight } = wrapperRef?.current?.getBoundingClientRect();
        wrapperTopPosition = wrapperHeight + wrapperTop;
      } else {
        wrapperTopPosition = tooltipTop;
      }
      const remainingHeight = window.innerHeight - wrapperTopPosition - tooltipHeight - y_offset;
      const isOverflowing = remainingHeight < 0;

      if (isOverflowing) {
        tooltipRef.current.style.top = `${-tooltipHeight - y_offset}px`;
      } else {
        if (wrapperRef) {
          tooltipRef.current.style.top = topPosition ? `${topPosition}px` : `calc(100% + ${y_offset}px)`;
        } else {
          // Try to back to the initial 100% top position
          if (remainingHeight > tooltipHeight + y_offset) {
            tooltipRef.current.style.top = `calc(100% + ${y_offset}px)`;
          }
        }
      }

      if (moveable) {
        if (wrapperRef?.current) {
          const { right: wrapperRight, left: wrapperLeft } = wrapperRef.current.getBoundingClientRect();
          if (wrapperRight < tooltipLeft + tooltipWidth) {
            const calculatedRight = tooltipLeft + tooltipWidth - wrapperRight + x_offset;
            tooltipRef.current.style.transform = `translateX(-${calculatedRight}px)`;
          } else if (wrapperLeft > tooltipLeft) {
            const calculatedLeft = wrapperLeft - tooltipLeft + x_offset;
            tooltipRef.current.style.transform = `translateX(${calculatedLeft}px)`;
          }
        }
      }
    }
  }, [isHover]);

  return (
    <>
      {!isMobileView ? (
        <div
          ref={tooltipRef}
          className={cx(styles.hoverTooltip, classNameTooltip, {
            [styles.isHover]: isHover,
            [styles.fullwidth]: fullwidth,
            [styles.right]: position === 'right',
            [styles.middle]: position === 'middle',
            [styles.left]: position === 'left',
          })}
          style={tooltipStyle}
        >
          {children ? children : <span className={cx(styles.hoverText, classNameText)}>{text}</span>}
        </div>
      ) : null}
    </>
  );
};

export default Tooltip;
